import React from 'react'

export default (props: any) => (
  <svg {...props} width="389" height="141" viewBox="0 0 389 141" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_17_316)">
      <path
        d="M131.527 101.625C132.794 100.673 134.01 99.668 135.177 98.61C130.183 109.795 122.367 119.489 112.495 126.741C102.624 133.993 91.0366 138.554 78.8704 139.976C66.7043 141.399 54.3773 139.633 43.0994 134.853C31.8215 130.074 21.98 122.444 14.5409 112.713C7.10176 102.981 2.32057 91.483 0.666527 79.3462C-0.987517 67.2093 0.542422 54.851 5.1062 43.4839C9.66998 32.1169 17.1108 22.1317 26.6984 14.5083C36.286 6.88489 47.6909 1.88525 59.794 0C58.4594 0.851123 57.1687 1.7693 55.927 2.751C42.8155 12.7762 34.2235 27.5993 32.0411 43.9594C29.8588 60.3195 34.2648 76.8765 44.29 89.988C54.3152 103.1 69.1383 111.692 85.4984 113.874C101.859 116.056 118.415 111.65 131.527 101.625V101.625Z"
        fill="#263D59"
      />
      <path
        d="M236.011 18.622L229.028 17.722L224.267 23.012L222.997 16.029L216.49 13.173L222.732 9.78701L223.473 2.75101L228.605 7.61801L235.535 6.13701L232.467 12.537L236.011 18.622Z"
        fill="#22374C"
      />
      <path
        d="M302.033 105.963L297.801 103.053L293.04 104.853L294.521 99.933L291.347 95.912L296.479 95.859L299.279 91.574L300.972 96.441L305.892 97.816L301.766 100.884L302.033 105.963Z"
        fill="#22374C"
      />
      <path
        d="M388.37 25.446L383.556 25.816L381.175 29.995L379.323 25.604L374.615 24.599L378.265 21.478L377.736 16.664L381.862 19.15L386.253 17.193L385.142 21.848L388.37 25.446Z"
        fill="#22374C"
      />
    </g>
    <defs>
      <clipPath id="clip0_17_316">
        <rect width="388.37" height="140.486" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
